<template>
  <div class="p-20 justify-content-center">
    <table class="table no-margin">
      <!-- Table Body -->
      <tbody>
        <tr class="table-heading">
          <td>
            <div class="d-flex flex-row align-items-center gap-10 table-heading">
              {{"Metadata of"|trans}} <strong>{{ this.currentOutput.filename }}</strong>
            </div>
          </td>
        </tr>
        <tr class="try-now">
          <td>
            <div class="d-flex flex-row align-items-center justify-content-between gap-10">
              <div class="gap-15 text-break align-items-center d-flex flex-row">
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 14C9.255 14 9.4689 13.9136 9.6417 13.7408C9.8145 13.568 9.9006 13.3544 9.9 13.1V9.5C9.9 9.245 9.8136 9.0311 9.6408 8.8583C9.468 8.6855 9.2544 8.5994 9 8.6C8.745 8.6 8.5311 8.6864 8.3583 8.8592C8.1855 9.032 8.0994 9.2456 8.1 9.5V13.1C8.1 13.355 8.1864 13.5689 8.3592 13.7417C8.532 13.9145 8.7456 14.0006 9 14ZM9 6.8C9.255 6.8 9.4689 6.7136 9.6417 6.5408C9.8145 6.368 9.9006 6.1544 9.9 5.9C9.9 5.645 9.8136 5.4311 9.6408 5.2583C9.468 5.0855 9.2544 4.9994 9 5C8.745 5 8.5311 5.0864 8.3583 5.2592C8.1855 5.432 8.0994 5.6456 8.1 5.9C8.1 6.155 8.1864 6.3689 8.3592 6.5417C8.532 6.7145 8.7456 6.8006 9 6.8ZM9 18.5C7.755 18.5 6.585 18.2636 5.49 17.7908C4.395 17.318 3.4425 16.6769 2.6325 15.8675C1.8225 15.0575 1.1814 14.105 0.7092 13.01C0.237 11.915 0.0006 10.745 0 9.5C0 8.255 0.2364 7.085 0.7092 5.99C1.182 4.895 1.8231 3.9425 2.6325 3.1325C3.4425 2.3225 4.395 1.6814 5.49 1.2092C6.585 0.737 7.755 0.5006 9 0.5C10.245 0.5 11.415 0.7364 12.51 1.2092C13.605 1.682 14.5575 2.3231 15.3675 3.1325C16.1775 3.9425 16.8189 4.895 17.2917 5.99C17.7645 7.085 18.0006 8.255 18 9.5C18 10.745 17.7636 11.915 17.2908 13.01C16.818 14.105 16.1769 15.0575 15.3675 15.8675C14.5575 16.6775 13.605 17.3189 12.51 17.7917C11.415 18.2645 10.245 18.5006 9 18.5ZM9 16.7C11.01 16.7 12.7125 16.0025 14.1075 14.6075C15.5025 13.2125 16.2 11.51 16.2 9.5C16.2 7.49 15.5025 5.7875 14.1075 4.3925C12.7125 2.9975 11.01 2.3 9 2.3C6.99 2.3 5.2875 2.9975 3.8925 4.3925C2.4975 5.7875 1.8 7.49 1.8 9.5C1.8 11.51 2.4975 13.2125 3.8925 14.6075C5.2875 16.0025 6.99 16.7 9 16.7Z" fill="#2D5089"/>
                </svg>
                <div>
                  {{"To see all file info please visit"|trans}} <strong @click="setTryNowUrl" class="cursor-pointer">{{"Metadata2Go.com"|trans}}</strong>
                </div>
              </div>
              <div>
                <button class="btn submit-btn white-space-nowrap" @click.stop.prevent="setTryNowUrl">
                  <strong>{{"Try Now"|trans}}</strong>
                  <i class="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="this.currentOutput.filename">
          <td>
            <div class="d-flex flex-row align-items-center gap-10">
              <div class="font-weight-bold col-4 px-0 text-break">{{"file_name"|trans}}</div>
              <div class="col-8 px-0 text-break">{{ this.currentOutput.filename }}</div>
            </div>
          </td>
        </tr>
        <tr v-if="this.currentOutput.size">
          <td>
            <div class="d-flex flex-row align-items-center gap-10">
              <div class="font-weight-bold col-4 px-0 text-break">{{"file_size"|trans}}</div>
              <div class="col-8 px-0 text-break">{{ setFileSize(this.currentOutput.size) }}</div>
            </div>
          </td>
        </tr>
        <tr v-if="this.currentOutput.content_type">
          <td>
            <div class="d-flex flex-row align-items-center gap-10">
              <div class="font-weight-bold col-4 px-0 text-break">{{"file_type"|trans}}</div>
              <div class="col-8 px-0 text-break">{{ setType(this.currentOutput.content_type) }}</div>
            </div>
          </td>
        </tr>
        <tr v-if="this.currentOutput.filename ">
          <td>
            <div class="d-flex flex-row align-items-center gap-10">
              <div class="font-weight-bold col-4 px-0 text-break">{{"file_type_extension"|trans}}</div>
              <div class="col-8 px-0 text-break">{{ setExtension(this.currentOutput.filename) }}</div>
            </div>
          </td>
        </tr>
        <tr v-if="this.currentOutput.metadata && this.currentOutput.metadata.image_width">
          <td>
            <div class="d-flex flex-row align-items-center gap-10">
              <div class="font-weight-bold col-4 px-0 text-break">{{"image_width"|trans}}</div>
              <div class="col-8 px-0 text-break">{{ this.currentOutput.metadata.image_width }}</div>
            </div>
          </td>
        </tr>
        <tr v-if="this.currentOutput.metadata && this.currentOutput.metadata.image_height">
          <td>
            <div class="d-flex flex-row align-items-center gap-10">
              <div class="font-weight-bold col-4 px-0 text-break">{{"image_height"|trans}}</div>
              <div class="col-8 px-0 text-break">{{ this.currentOutput.metadata.image_height }}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="try-now rounded border mt-4 padding-10">
      <p>{{"The data shown is all the metadata we could automatically extract from your file."|trans}}</p>
      <p>{{"It may be neither complete nor adequate."|trans}}</p>
      <p>{{"Metadata could have been changed or deleted in the past. Please be aware that the metadata is provided without liability."|trans}}</p>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import { formatting } from '../../../../../../../helper/formatting';
import { satGlobals } from '../../../../../../../sat/helper/sat-globals';

export default {
  name: "MetaInfo",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {},
  created: function () {
  },
  methods: {
    setFileSize(size) {
      return formatting.fileSize(size);
    },
    setType(type){
      const index = type.indexOf('/')
      return type.slice(index+1).toUpperCase()
    },
    setExtension(extension){
      const index = extension.indexOf('.')
      return extension.slice(index+1)
    },
    setTryNowUrl(){
      let baseDomain = satGlobals.getBaseDomain();

      const locale = satGlobals.getLocale();
      let url = satGlobals.getMainUrl();
      
      if (locale !== 'en') {
        baseDomain = baseDomain + '/' + locale;
        url = url + '/' + locale;
      }

      const newUrl = url.replace(baseDomain, `metadata2go.com/view-metadata`)
      
      window.open(newUrl)
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.table{
  background: #FFFFFF;
  border: 1px solid #CBCBCB;
}
.try-now{
  background-color: #D9E7FD;
  color:#2D5089;
  p{
    padding:0px;
    margin: 4px 0;
  }
}
tr{
  height: 54px;
}
td{
  vertical-align: middle;
}
.padding-10{
  padding:10px;
}
.table-heading{
  background: #FBFBFB;
}
</style>
